// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_11792"};